import { PRODUCTS_DASHBOARD_TABS_MAP } from './constants';

export type ProductsDashboardTabKey = (typeof PRODUCTS_DASHBOARD_TABS_MAP)[keyof typeof PRODUCTS_DASHBOARD_TABS_MAP];

const isProductsDashboardTabKey = (tab: string): tab is ProductsDashboardTabKey =>
    Object.values(PRODUCTS_DASHBOARD_TABS_MAP).includes(tab as ProductsDashboardTabKey);

/**
 * Список вкладок дашборда товаров, доступных для типа магазина.
 *
 * @kind helper
 * @param isLiteStore - магазин KIT Lite
 * @returns ключи доступных вкладок
 */
export function getProductsDashboardAvailableTabs(isLiteStore: boolean): ProductsDashboardTabKey[] {
    return isLiteStore
        ? [
              PRODUCTS_DASHBOARD_TABS_MAP.allVariants,
              PRODUCTS_DASHBOARD_TABS_MAP.moderation,
              PRODUCTS_DASHBOARD_TABS_MAP.archivedVariants,
          ]
        : [
              PRODUCTS_DASHBOARD_TABS_MAP.allVariants,
              PRODUCTS_DASHBOARD_TABS_MAP.cards,
              PRODUCTS_DASHBOARD_TABS_MAP.archivedVariants,
          ];
}

/**
 * Определяет активную вкладку дашборда товаров по значению из URL.
 *
 * @kind helper
 * @param tabFromUrl - значение search param `active-tab`
 * @param isLiteStore - магазин KIT Lite
 * @returns активная вкладка и признак валидности значения из URL
 */
export function resolveProductsDashboardActiveTab(
    tabFromUrl: string,
    isLiteStore: boolean
): { activeKey: ProductsDashboardTabKey; isTabFromUrlValid: boolean } {
    const defaultTab = PRODUCTS_DASHBOARD_TABS_MAP.allVariants;
    const availableTabs = getProductsDashboardAvailableTabs(isLiteStore);

    if (!tabFromUrl) {
        return { activeKey: defaultTab, isTabFromUrlValid: true };
    }

    if (isProductsDashboardTabKey(tabFromUrl) && availableTabs.includes(tabFromUrl)) {
        return { activeKey: tabFromUrl, isTabFromUrlValid: true };
    }

    return { activeKey: defaultTab, isTabFromUrlValid: false };
}
